/* eslint-disable camelcase */
import { ICreateLikeData, ICreateLikeInputData, TMapyBoxType } from "~/interfaces";
import Notifications, { NOTIFICATIONS_TYPE } from "~/util/notifications";

const EMAIL_REGEXP = /[+-_!#$%&'*=?{|}~^/a-z0-9]+(\.[+-_!#$%&'*=?{|}~^/a-z0-9]+)*(\.*@seznam|\.*@email|\.*@post|\.*@spoluzaci|\.*@firmy|\.*@stream|@[a-z0-9-]+)(\.[a-z0-9-]+)*(\.[a-z-]{2,20})/igu;
const PHONE_REGEXP = /([+]\d{2,3}[ ]?)?[1-9][0-9]{2}[ ]?\d{3}[ ]?\d{3,4}/ug;

function stripLinkHtml(value: string) {
	return value.replace(/<a.*<\/a>/ug, "");
}

// route: data.routeItems,
// source_id: data.source_id, misto id
export function getCreateLikeData(data: ICreateLikeInputData, type: TMapyBoxType, folderId?: string) {
	// @ts-ignore
	let likeData: ICreateLikeData = {};
	let coords = null;
	const title = data.title.trim();
	const description = (data.description || "").trim();

	switch (type) {
		case "point":
			coords = data.coords.toWGS84();

			likeData = {
				type,
				title,
				description,
				mark: {
					lat: coords[1],
					lon: coords[0],
				},
			};
			break;

		case "entity":
			coords = data.coords.toWGS84();

			likeData = {
				type,
				title,
				description,
				source: data.source,
				source_id: data.source_id,
				mark: {
					lat: coords[1],
					lon: coords[0],
				},
			};
			break;

		case "measure":
			likeData = {
				type,
				title,
				description,
				data: {
					points: data.points,
				},
			};

			if (data.readonly) {
				likeData.data.readonly = data.readonly;
			}

			if ("tid" in data) {
				likeData.data.tid = data.tid;
			}
			break;

		case "path":
			likeData = {
				data: {
					data: [{
						route: data.route,
					}],
				},
				title: title || data.title,
				usertitle: title || data.title,
				description,
				trackType: data.trackType || "pesky",
				type: "path",
			};
			break;

		// uzivatelske znacky
		case "set":
			likeData = {
				type,
				title,
				description,
				data: {
					uc: data.uc,
					ud: data.ud,
					ut: data.ut,
				},
			};
			break;

		case "route":
			likeData = {
				type,
				title,
				description,
				data: {
					route: data.routeItems,
					totalLength: data.totalLength,
					totalTime: data.totalTime,
					geometry: data.geometry,
					routeParams: data.routeParams,
				},
			};
			break;

		// neni v db, specialni pro presun
		case "move":
			likeData = {
				title,
				description,
				ids: data.ids,
				actualFolderId: data.actualFolderId,
			};
			break;

		case "rename-move":
			likeData = {
				title,
				description,
				ids: data.ids,
				actualFolderId: data.actualFolderId,
			};
			break;

		// neni v db, specialni pro kopirovani
		case "copy":
			likeData = {
				id: data.id,
				title,
				description,
				type: data.type,
			};
			break;

		case "track":
			likeData = {
				title,
				description,
				id: data.id,
			};
			break;

		default:
	}

	if (data.subtitle) {
		likeData.subtitle = data.subtitle;
	}

	if (data.usertitle) {
		likeData.usertitle = data.usertitle;
	}

	// folder id
	if (folderId) {
		likeData.parent_id = folderId;
	}

	return likeData;
}

interface IMapyboxNotification {
	msg: string;
	type?: "success" | "error" | "question" | "info";
	folderTitle?: string;
	folderId?: string;
}

export function mapyboxNotification({
	msg,
	type = "success",
	folderId = "",
	folderTitle = "",
}: IMapyboxNotification) {
	const content = Mapy.Util.node("p", { className: "addpopup-notification", textContent: msg });

	if (folderTitle) {
		const folderEl = Mapy.Util.node("span", { className: "folder-name", textContent: ` ${folderTitle}` });

		folderEl.setAttribute("data-folder-id", folderId);
		folderEl.addEventListener("click", () => {
			Mapy.getComponent("mymaps").setState({
				mid: folderId,
				cat: "mista-trasy",
			});

			if (Mapy.getComponent("mymaps").activate()) {
				Mapy.getComponent("mymaps").deactivate();
			}

			Mapy.getComponent("mymaps").activate();
			Mapy.getComponent("mymaps").activeComponent(Mapy.getComponent("places"));
			Mapy.getComponent("history").save();
		});
		content.appendChild(folderEl);
	}

	let notifyType = NOTIFICATIONS_TYPE.SUCCESS;

	switch (type) {
		case "error":
			notifyType = NOTIFICATIONS_TYPE.ERROR;
			break;

		case "info":
			notifyType = NOTIFICATIONS_TYPE.INFO;
			break;

		case "question":
			notifyType = NOTIFICATIONS_TYPE.QUESTION;
			break;

		default:
	}

	Notifications.notify({
		content,
		type: notifyType,
	});
}

export function isPoiSaved(source: string, id: number) {
	return Mapy.getComponent("places").isSaved({
		source,
		id,
	});
}

function applyRegex(description: string, regex: any, replaceCb: (oldValue: string) => string) {
	let updatedDescription = description;
	// budeme testovat text ale bez odkazu, abysme si je neprepisovali
	const matches = stripLinkHtml(description).match(regex);

	if (matches) {
		for (let ind = 0, max = matches.length; ind < max; ind++) {
			const matchedValue = matches[ind];

			updatedDescription = updatedDescription.replace(matchedValue, replaceCb(matchedValue));
		}
	}

	return updatedDescription;
}

function getLink(url: string) {
	const fullUrl = url.includes("http") ? url : `https://${url}`;

	return `<a href="${fullUrl}" target="_blank" rel="noopener">${fullUrl}</a>`;
}

export function getHTMLDescription(description: string): string {
	// smazeme tagy
	const newDescription = applyRegex(description, /[<][^>]+[>]/ug, () => "");
	const lines = newDescription.split("\n");
	const output: Array<string> = [];

	for (const line of lines) {
		let newLine = line;

		// nahradime url - http/https + www
		newLine = applyRegex(newLine, /http[^ \t\n]+/ug, url => getLink(url));
		newLine = applyRegex(newLine, /www\.[^ \t\n]+/ug, url => getLink(url));

		// emaily
		newLine = applyRegex(newLine, EMAIL_REGEXP, email => `<a href="mailto:${email}">${email}</a>`);
		// telefon
		newLine = applyRegex(newLine, PHONE_REGEXP, phone => `<a href="tel:${phone}">${phone}</a>`);

		output.push(newLine);
	}

	return output.join("\n");
}
